{
  "id": "campaign-019",
  "name": "Untamed Run",
  "seed": "campaign:19",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "HHH,,,,,,,..",
    "HHH,,,,,,...",
    "___,,,,.....",
    ",,,,,,.,,...",
    ",,,,,,,,,,..",
    ",,,,,,,,,,,,",
    ",T,,T..T,,T,",
    ",,,,.......,",
    ",,,,......#.",
    "~~~,B..B....",
    ",~,,..#.....",
    "____________",
    ",,,,,,,,,...",
    "..,,,,,,....",
    "S...#,,,...."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 11,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 7
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 9
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 6,
      "y": 1
    },
    {
      "kind": "gas",
      "x": 9,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 9
    },
    {
      "kind": "repair",
      "x": 10,
      "y": 12
    }
  ],
  "generatorVersion": 3,
  "level": 19,
  "biome": "backyard",
  "par": {
    "reel": 12497,
    "push": 7988,
    "selfPropelled": 7203,
    "tractor": 4636,
    "zeroTurn": 5178,
    "fairway": 2969
  },
  "routeTries": {
    "par": {
      "reel": 20,
      "push": 15,
      "selfPropelled": 16,
      "tractor": 7,
      "zeroTurn": 5,
      "fairway": 17
    }
  }
}
